export default {
  computed: {
    $_currentGeoSection() {
      const area = this.$store.state.generalArea
      switch (area) {
        case 'all':
          return 'Sverige'
        case 'ost':
          return 'Östersjön'
        case 'vast':
          return 'Västerhavet'
        case 'ab':
          return 'Stockholms län'
        case 'c':
          return 'Uppsala län'
        case 'd':
          return 'Södermanlands län'
        case 'e':
          return 'Östergötlands län'
        case 'h':
          return 'Kalmar län'
        case 'i':
          return 'Gotlands län'
        case 'm':
          return 'Blekinge län'
        case 'k':
          return 'Skåne län'
        case 'n':
          return 'Hallands län'
        case 'o':
          return 'Västra Götaland län'
        case 'x':
          return 'Gävleborgs län'
        case 'y':
          return 'Västernorrlands län'
        case 'ac':
          return 'Västerbottens län'
        case 'bd':
          return 'Norrbottens län'
        default:
          return 'Sverige'
      }
    },
    $_currentGeoSectionExtra() {
      const area = this.$store.state.generalArea
      switch (area) {
        case 'all':
          return 'svenska hav'
        case 'ost':
          return 'Östersjön'
        case 'vast':
          return 'Västerhavet'
        case 'ab':
          return 'Stockholms län'
        case 'c':
          return 'Uppsala län'
        case 'd':
          return 'Södermanlands län'
        case 'e':
          return 'Östergötlands län'
        case 'h':
          return 'Kalmar län'
        case 'i':
          return 'Gotlands län'
        case 'm':
          return 'Blekinge län'
        case 'k':
          return 'Skånes län'
        case 'n':
          return 'Hallands län'
        case 'o':
          return 'Västra Götalands län'
        case 'x':
          return 'Gävleborgs län'
        case 'y':
          return 'Västernorrlands län'
        case 'ac':
          return 'Västerbottens län'
        case 'bd':
          return 'Norrbottens län'
        default:
          return 'svenska hav'
      }
    }
  },
  methods: {},
  filters: {}
}
